import { logger } from "./logger";
import { domReadyLegacy } from "./../utils/ready";
import { analyticsTrack } from "../utils/analytics";
import { addListener } from "../utils/event-listeners";

type Variables = Record<string, never>;

function extractFilterOptionType(element: Element): string | null {
  const className = element.getAttribute("class");

  if (!className) {
    return null;
  }

  const matches = className.match(/filters_.*/gm);

  if (!matches || matches.length == 0) {
    return null;
  }

  return matches[0].substr(8);
}

function trackEvent(
  name: string,
  payload: {
    eventAction: string;
    eventLabel: string;
    eventValue: string;
  }
) {
  if (window.ga) {
    window.ga("send", {
      hitType: "event",
      eventCategory: name,
      ...payload,
    });
  } else {
    logger.warn("Google Analytics is not installed");
  }

  if (window.analytics) {
    analyticsTrack(name, payload);
  } else {
    logger.warn("Visitor Event is not installed");
  }
}

export function installFilters(): void {
  const desktopFilters = document?.body?.querySelector(
    ".desktop_filters_adaptive"
  );

  if (desktopFilters == null) {
    return;
  }

  const children = desktopFilters.children;

  for (let i = 0; i < children.length; i++) {
    const filterOptionType = extractFilterOptionType(children[i]);

    if (!filterOptionType) {
      continue;
    }

    const checkboxContainers = children[i].querySelectorAll<HTMLDivElement>(
      ".checkbox_input_container"
    );

    checkboxContainers.forEach((container) => {
      const checkbox = container.querySelector("input");

      if (!checkbox) {
        return;
      }

      addListener(
        container,
        "click",
        function (e) {
          // Check to see if we're on capturing phase
          // This needs to happen before the inline onclick event
          // So the page does not reload
          if (e.eventPhase != 1) return;

          const checkedState = checkbox.getAttribute("checked");

          trackEvent("Product Catalog Filter Option", {
            eventAction: checkedState === "checked" ? "removed" : "applied",
            eventLabel: filterOptionType,
            eventValue: "0",
          });
        },
        true
      );
    });
  }
}

export function install(_: Variables): void {
  domReadyLegacy(installFilters);
}
